export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-16"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-primary-50/30 to-accent-50/40"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>日漫韩漫 · 完结漫画 · 下拉式全集</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              亲亲漫画网 · 漫画全集免费在线看
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading mb-6">
              下拉式全集流畅阅读，完结日漫韩漫一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              亲亲漫画网专注漫画全集免费阅读，收录海量完结日漫韩漫大全。采用下拉式全集阅读模式，无需翻页即可流畅浏览全部章节，一次性看完整部作品。每日持续更新热门连载，完结作品即时入库，为漫画爱好者打造最便捷的全集在线阅读平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">完结作品收录</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">200+</div>
                <div className="text-xs text-foreground-500 mt-1">每日章节更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-600 font-heading">100%</div>
                <div className="text-xs text-foreground-500 mt-1">免费无广告干扰</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#index');
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                开始阅读
              </a>
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#carousel');
                }}
                className="w-full sm:w-auto px-8 py-3 bg-background-50 text-foreground-700 rounded-lg font-medium text-sm border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                查看专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20vibrant%20manga%20reading%20scene%20on%20a%20tablet%20device%20displaying%20colorful%20Japanese%20manga%20pages%20with%20action%20scenes%2C%20surrounded%20by%20warm%20ambient%20lighting%2C%20cozy%20reading%20atmosphere%20with%20soft%20bokeh%20background%2C%20artistic%20illustration%20style%20with%20rich%20warm%20orange%20and%20cream%20tones%2C%20clean%20composition%2C%20editorial%20quality&width=900&height=675&seq=hero-manga-01&orientation=landscape"
                alt="亲亲漫画网 - 漫画全集在线阅读体验"
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}